import config from '../config/config';
import { useApiMutation } from './useApiMutation';
import { logger } from '../Logger';
import { MethodType } from '../types/ApiRequest';

export const useLogout = () => {

  const mutation = useApiMutation<{ sessionId: string; userUid: string }>({
    url: `${config.tcTeamsWebApiUrl}/auth/logout`,
    method: MethodType.POST,
    key: 'logout',
    action: 'useLogout'
  }, logger);

  return mutation;
};
